import axios from 'axios';
import { config } from './utils';

export type UploadAssetResult = {
  id: string;
  key: string;
  mimeType: string;
};

const toUploadResult = (data: any): UploadAssetResult | null => {
  if (!data?.id) {
    return null;
  }

  return {
    id: data.id,
    key: data.keypath || data.key || '',
    mimeType: data.mimeType || data.fileType || '',
  };
};

export const UploadAssetsApiCall = async (
  file: any,
  organizationId: string,
  token: string,
  uploadType: string,
  moduleId?: string
): Promise<UploadAssetResult | null> => {
  const formData = new FormData();
  formData.append('uploadType', file);
  formData.append('organizationId', organizationId);

  let url = `${config.BASE_URL}/upload-asset?uploadType=${uploadType}`;
  if (organizationId) {
    url += `&organizationId=${organizationId}`;
  }
  if (moduleId) {
    url += `&moduleId=${moduleId}`;
  }

  try {
    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return toUploadResult(response?.data);
  } catch {
    return null;
  }
};
